import { render, staticRenderFns } from "./add.vue?vue&type=template&id=1a586fb5&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a586fb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a586fb5')) {
      api.createRecord('1a586fb5', component.options)
    } else {
      api.reload('1a586fb5', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=1a586fb5&scoped=true&", function () {
      api.rerender('1a586fb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/web/info/add.vue"
export default component.exports